import { AnalyticIdentifier } from '@common/neo.tax';

import { useAnalyticId } from '@neo.tax/shared/state';

interface PayrollProviderIds {
  gustoRadioId: string;
  justworksRadioId: string;
  ripplingRadioId: string;
  trinetRadioId: string;
  quickbooksRadioId: string;
  adpRunRadioId: string;
  adpWorkforceNowRadioId: string;
  ceridianDayforceRadioId: string;
  payChexFlexRadioId: string;
  paylocityRadioId: string;
  workdayRadioId: string;
  zenefitsRadioId: string;
  csvRadioId: string;
}

export const usePayrollProviderIds = (): PayrollProviderIds => ({
  gustoRadioId: useAnalyticId(AnalyticIdentifier.RTC_SELECT_LINK_GUSTO),
  justworksRadioId: useAnalyticId(AnalyticIdentifier.RTC_SELECT_LINK_JUSTWORKS),
  ripplingRadioId: useAnalyticId(AnalyticIdentifier.RTC_SELECT_LINK_RIPPLING),
  trinetRadioId: useAnalyticId(AnalyticIdentifier.RTC_SELECT_LINK_TRINET),
  quickbooksRadioId: useAnalyticId(AnalyticIdentifier.RTC_SELECT_LINK_QUICKBOOKS_PAYROLL),
  adpRunRadioId: useAnalyticId(AnalyticIdentifier.RTC_SELECT_LINK_ADP_RUN),
  adpWorkforceNowRadioId: useAnalyticId(AnalyticIdentifier.RTC_SELECT_LINK_ADP_WORKFORCE_NOW),
  ceridianDayforceRadioId: useAnalyticId(AnalyticIdentifier.RTC_SELECT_LINK_CERIDIAN_DAYFORCE),
  payChexFlexRadioId: useAnalyticId(AnalyticIdentifier.RTC_SELECT_LINK_PAYCHEX_FLEX),
  paylocityRadioId: useAnalyticId(AnalyticIdentifier.RTC_SELECT_LINK_PAYLOCITY),
  workdayRadioId: useAnalyticId(AnalyticIdentifier.RTC_SELECT_LINK_WORKDAY),
  zenefitsRadioId: useAnalyticId(AnalyticIdentifier.RTC_SELECT_LINK_ZENEFITS),
  csvRadioId: useAnalyticId(AnalyticIdentifier.RTC_SELECT_UPLOAD_PAYROLL_CSV),
});
